import { useState } from "react";
import { useTranslation } from "react-i18next";

function FAQs() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0); // первый открыт

  const faqs = [
    {
      q: t("home.39"),
      a: t("home.40"),
    },
    {
      q: t("home.41"),
      a: t("home.42"),
    },
    {
      q: t("home.43"),
      a: t("home.44"),
    },
    {
      q: t("home.45"),
      a: t("home.46"),
    },
    {
      q: t("home.47"),
      a: t("home.48"),
    },
  ];

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col gap-6">
        <p className="text-[#061A77] font-[500] leading-[1.2] poppins text-[24px] xl:text-[32px]">
          {t("home.38")}
        </p>

        <div className="flex flex-col gap-3">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className="bg-[#F4F7FF] rounded-[4px] overflow-hidden transition-all"
              >
                {/* Header */}
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left"
                >
                  <span className="text-[#0A1B6F] font-medium">
                    {item.q}
                  </span>

                  <span className="flex items-center flex-shrink-0 justify-center w-6 h-6 rounded-full border border-[#0A1B6F] text-[#0A1B6F] text-sm font-bold">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                {/* Content */}
                <div
                  className={`px-6 transition-all duration-300 ease-in-out ${
                    isOpen
                      ? "max-h-[300px] opacity-100 pb-5"
                      : "max-h-0 opacity-0 pb-0"
                  }`}
                >
                  <p className="text-[#5B6478] text-sm leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default FAQs;
